// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input.form-control[data-v-1a743662]{height:34px;border-radius:10px!important}.avatar-select[data-v-1a743662]{position:absolute;top:1px;left:1px;border-radius:10px 0 0 10px!important;z-index:1}.indent[data-v-1a743662]{padding-left:50px!important}.flex-start-image[data-v-1a743662]{top:1px;position:relative}.subtitle[data-v-1a743662]{margin-top:5px;font-size:12px!important;font-weight:400!important;text-align:left!important;color:#7c8b91!important}", ""]);
// Exports
module.exports = exports;
